import React, { Component } from 'react';
import axios from "axios/dist/axios.min.js";
import utils from "../../utils/utils";
import './style.less';

class PipelineRankList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rankList: []
    };
  }

  componentDidMount(){
    this.getRankList();
  }

  getRankList = () => {
    const itemList = this.props.config.rankConfig;
    const idList = itemList.map((item) => {
      return item.id ? item.id : '0';
    });
    axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-goodsinnerapi/api/inner/top/info?access_token=WphjwI564K8kzs5JQZ',
      method: "post",
      withCredentials: true,
      data: {
        topListIds: idList,
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const list = res.data.data || [];
        // 插入定制化内容
        list.forEach((product) => {
          const customItem = itemList.find((item) => item.id == product.id);
          if (customItem) {
            product.name = customItem.title;
          }
        });
        this.setState({
          rankList: list
        })
      }
    });
  }

  // 更多跳转
  handleMoreClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.href,
        props: this.props,
        index
      })
      return
    }

    const url = item.href;
    const options = {
      title: 5,
      topic_id: item.id,
    };

    const convertUrl = utils.convertHref(url);
    utils.jumpToUrl(this.props.routeParams,convertUrl,url,options,-1,this.props,false,{blockName: 'more'});
  }

  // 商品跳转
  handleItemClick = (topic, item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.href,
        props: this.props,
        index
      })
      return
    }

    const baseConfig = this.props.config.baseConfig;
    const options = {
      title: 5,
      sort: index,
      goods_id: item.goods_id,
      style_id: item.style_id,
      topic_id: topic.id,
    };
    utils.jumpToUrl(this.props.routeParams,item.href,item.href,options,item.id,this.props);
  }

  render() {
    const { rankList } = this.state;
    const { componentDivideLine } = this.props
    const { rankTitleBg, goodsBodyBg, arrowIcon, arrowIcon2, txtColor, moreTxtBg, priceTxtColor, comBgColor, priceBackgroundImage } = this.props.config
    const priceBgImage = priceBackgroundImage || "https://static.shihuocdn.cn/admin/files/20210328/79d63b36465d81102489beca5744a012.png";
    return (
      <div className="pipeline-rankList" style={{backgroundColor: comBgColor}} {...this.props['customAttributes']}>
        <div className="title-img">
          <img src={utils.formatImgUrl(this.props.config.titleImage, this.props.webpSupport)} />
        </div>
        {
          rankList.map((item, index) => {
            return (
              <div className="rank-body" key={`rank-${index}`}>
                <div className="rank-title" style={{backgroundColor: rankTitleBg, color: txtColor}}>
                  {item.name}
                  {/* <img src="https://static.shihuocdn.cn/admin/files/20210328/e9ab042d5b4c4c015a48601a6e1a713e.png" /> */}
                  <img src={utils.formatImgUrl(arrowIcon, this.props.webpSupport)} />
                </div>
                <div className="rank-more"style={{color: txtColor, backgroundColor: moreTxtBg}}  onClick={this.handleMoreClick.bind(this, item, index)}>
                  查看更多
                  {/* <img src="https://static.shihuocdn.cn/admin/files/20210328/59dd0e500136985624e6f421a53d31ac.png" /> */}
                  <img src={utils.formatImgUrl(arrowIcon2, this.props.webpSupport)} />
                </div>
                <div className="goods-body" style={{backgroundColor: goodsBodyBg}}>
                  <div className="goods-scroll">
                    {
                      item.top_detail && item.top_detail.map((item2, index2) => {
                        if (index2 <= 6) {
                          return (
                            <div className="goods-item" key={`goods-${index2}`} onClick={this.handleItemClick.bind(this, item, item2, index2)}>
                              <div className="goods-item-title">{item2.name}</div>
                              <div className="goods-item-img">
                                <img src={utils.formatImgUrl(item2.pic, this.props.webpSupport)} />
                              </div>
                              <div className="goods-item-bottom" style={{backgroundImage: `url(${utils.formatImgUrl(priceBgImage, this.props.webpSupport)})`}}>
                                <div className="goods-item-originalprice">
                                  <span>到手价:</span>
                                </div>
                                <div className="goods-item-price" style={{color: priceTxtColor}}>
                                  <span>¥</span>
                                  <span>{parseInt(item2.price)}</span>
                                </div>
                              </div>
                            </div>
                          )
                        }
                      })
                    }
                  </div>
                </div>
              </div>
            )
          })
        }
        {this.props.notLastItem && componentDivideLine &&  (
          <img className="component-divide-line" src={utils.formatImgUrl(componentDivideLine, this.props.webpSupport)} />
        )}
      </div>
    );
  }
}

export default PipelineRankList;



// WEBPACK FOOTER //
// ./components/pipeline-rankList/index.jsx